import { render, staticRenderFns } from "./Restaurante.vue?vue&type=template&id=4e171e09&"
import script from "./Restaurante.vue?vue&type=script&lang=js&"
export * from "./Restaurante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports